/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.47567.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class OrganizationApi extends runtime.BaseAPI {
    /**
     */
    async createOrganizationRaw(requestParameters, initOverrides) {
        if (requestParameters.createOrganizationOptions === null || requestParameters.createOrganizationOptions === undefined) {
            throw new runtime.RequiredError('createOrganizationOptions', 'Required parameter requestParameters.createOrganizationOptions was null or undefined when calling createOrganization.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrganizationOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOrganization(requestParameters, initOverrides) {
        const response = await this.createOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createOrganizationSamlSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling createOrganizationSamlSettings.');
        }
        if (requestParameters.createOrganizationSamlSettingsOptions === null || requestParameters.createOrganizationSamlSettingsOptions === undefined) {
            throw new runtime.RequiredError('createOrganizationSamlSettingsOptions', 'Required parameter requestParameters.createOrganizationSamlSettingsOptions was null or undefined when calling createOrganizationSamlSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrganizationSamlSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOrganizationSamlSettings(requestParameters, initOverrides) {
        const response = await this.createOrganizationSamlSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createOrganizationSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling createOrganizationSettings.');
        }
        if (requestParameters.createOrganizationSettingsOptions === null || requestParameters.createOrganizationSettingsOptions === undefined) {
            throw new runtime.RequiredError('createOrganizationSettingsOptions', 'Required parameter requestParameters.createOrganizationSettingsOptions was null or undefined when calling createOrganizationSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrganizationSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOrganizationSettings(requestParameters, initOverrides) {
        const response = await this.createOrganizationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAllRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteAll(initOverrides) {
        await this.deleteAllRaw(initOverrides);
    }
    /**
     */
    async deleteOrganizationRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling deleteOrganization.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteOrganization(requestParameters, initOverrides) {
        await this.deleteOrganizationRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteOrganizationSamlSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling deleteOrganizationSamlSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteOrganizationSamlSettings(requestParameters, initOverrides) {
        await this.deleteOrganizationSamlSettingsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteOrganizationSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling deleteOrganizationSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteOrganizationSettings(requestParameters, initOverrides) {
        const response = await this.deleteOrganizationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete organization settings image
     */
    async deleteOrganizationSettingsImageRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling deleteOrganizationSettingsImage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings/image`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Delete organization settings image
     */
    async deleteOrganizationSettingsImage(requestParameters, initOverrides) {
        const response = await this.deleteOrganizationSettingsImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteOrganizationUserRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling deleteOrganizationUser.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteOrganizationUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/{userId}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteOrganizationUser(requestParameters, initOverrides) {
        await this.deleteOrganizationUserRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getGenericSamlSpDataRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/saml-sp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getGenericSamlSpData(initOverrides) {
        const response = await this.getGenericSamlSpDataRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganization.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganization(requestParameters, initOverrides) {
        const response = await this.getOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationSamlServiceProviderDataRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationSamlServiceProviderData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml-sp`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationSamlServiceProviderData(requestParameters, initOverrides) {
        const response = await this.getOrganizationSamlServiceProviderDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationSamlSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationSamlSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationSamlSettings(requestParameters, initOverrides) {
        const response = await this.getOrganizationSamlSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationSettings(requestParameters, initOverrides) {
        const response = await this.getOrganizationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get organization settings image
     */
    async getOrganizationSettingsImageRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationSettingsImage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings/image`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Get organization settings image
     */
    async getOrganizationSettingsImage(requestParameters, initOverrides) {
        await this.getOrganizationSettingsImageRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getOrganizationUserForSessionRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationUserForSession.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/user`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationUserForSession(requestParameters, initOverrides) {
        const response = await this.getOrganizationUserForSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationUserLimitsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationUserLimits.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/users/limits`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationUserLimits(requestParameters, initOverrides) {
        const response = await this.getOrganizationUserLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationUsersRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationUsers.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/users`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationUsers(requestParameters, initOverrides) {
        const response = await this.getOrganizationUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationUsersPaginatedRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling getOrganizationUsersPaginated.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/all-users`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizationUsersPaginated(requestParameters, initOverrides) {
        const response = await this.getOrganizationUsersPaginatedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrganizationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrganizations(initOverrides) {
        const response = await this.getOrganizationsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async importOrganizationSamlSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling importOrganizationSamlSettings.');
        }
        if (requestParameters.importOrganizationSamlSettingsOptions === null || requestParameters.importOrganizationSamlSettingsOptions === undefined) {
            throw new runtime.RequiredError('importOrganizationSamlSettingsOptions', 'Required parameter requestParameters.importOrganizationSamlSettingsOptions was null or undefined when calling importOrganizationSamlSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml-import`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.importOrganizationSamlSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async importOrganizationSamlSettings(requestParameters, initOverrides) {
        const response = await this.importOrganizationSamlSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async inviteOrganizationUserRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling inviteOrganizationUser.');
        }
        if (requestParameters.inviteOrganizationUserOptions === null || requestParameters.inviteOrganizationUserOptions === undefined) {
            throw new runtime.RequiredError('inviteOrganizationUserOptions', 'Required parameter requestParameters.inviteOrganizationUserOptions was null or undefined when calling inviteOrganizationUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.inviteOrganizationUserOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async inviteOrganizationUser(requestParameters, initOverrides) {
        const response = await this.inviteOrganizationUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async inviteOrganizationUsersCsvRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling inviteOrganizationUsersCsv.');
        }
        if (requestParameters.csv === null || requestParameters.csv === undefined) {
            throw new runtime.RequiredError('csv', 'Required parameter requestParameters.csv was null or undefined when calling inviteOrganizationUsersCsv.');
        }
        if (requestParameters.userType === null || requestParameters.userType === undefined) {
            throw new runtime.RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling inviteOrganizationUsersCsv.');
        }
        const queryParameters = {};
        if (requestParameters.csv !== undefined) {
            queryParameters['csv'] = requestParameters.csv;
        }
        if (requestParameters.userType !== undefined) {
            queryParameters['userType'] = requestParameters.userType;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/users/csv`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async inviteOrganizationUsersCsv(requestParameters, initOverrides) {
        const response = await this.inviteOrganizationUsersCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async remindOrganizationsRaw(requestParameters, initOverrides) {
        if (requestParameters.remindOrganizationsOptions === null || requestParameters.remindOrganizationsOptions === undefined) {
            throw new runtime.RequiredError('remindOrganizationsOptions', 'Required parameter requestParameters.remindOrganizationsOptions was null or undefined when calling remindOrganizations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/reminder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.remindOrganizationsOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async remindOrganizations(requestParameters, initOverrides) {
        await this.remindOrganizationsRaw(requestParameters, initOverrides);
    }
    /**
     */
    async sendOrganizationUserAccessLinkRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling sendOrganizationUserAccessLink.');
        }
        if (requestParameters.organizationUserAccessLinkOptions === null || requestParameters.organizationUserAccessLinkOptions === undefined) {
            throw new runtime.RequiredError('organizationUserAccessLinkOptions', 'Required parameter requestParameters.organizationUserAccessLinkOptions was null or undefined when calling sendOrganizationUserAccessLink.');
        }
        const queryParameters = {};
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        if (requestParameters.isSignUp !== undefined) {
            queryParameters['isSignUp'] = requestParameters.isSignUp;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/access`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationUserAccessLinkOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async sendOrganizationUserAccessLink(requestParameters, initOverrides) {
        await this.sendOrganizationUserAccessLinkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async updateOrganizationSamlSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling updateOrganizationSamlSettings.');
        }
        if (requestParameters.updateOrganizationSamlSettingsOptions === null || requestParameters.updateOrganizationSamlSettingsOptions === undefined) {
            throw new runtime.RequiredError('updateOrganizationSamlSettingsOptions', 'Required parameter requestParameters.updateOrganizationSamlSettingsOptions was null or undefined when calling updateOrganizationSamlSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrganizationSamlSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateOrganizationSamlSettings(requestParameters, initOverrides) {
        const response = await this.updateOrganizationSamlSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateOrganizationSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling updateOrganizationSettings.');
        }
        if (requestParameters.updateOrganizationSettingsOptions === null || requestParameters.updateOrganizationSettingsOptions === undefined) {
            throw new runtime.RequiredError('updateOrganizationSettingsOptions', 'Required parameter requestParameters.updateOrganizationSettingsOptions was null or undefined when calling updateOrganizationSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrganizationSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateOrganizationSettings(requestParameters, initOverrides) {
        const response = await this.updateOrganizationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateOrganizationUserRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling updateOrganizationUser.');
        }
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling updateOrganizationUser.');
        }
        if (requestParameters.updateOrganizationUserOptions === null || requestParameters.updateOrganizationUserOptions === undefined) {
            throw new runtime.RequiredError('updateOrganizationUserOptions', 'Required parameter requestParameters.updateOrganizationUserOptions was null or undefined when calling updateOrganizationUser.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/{userId}`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOrganizationUserOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateOrganizationUser(requestParameters, initOverrides) {
        const response = await this.updateOrganizationUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload SAML IdP Metadata XML
     */
    async uploadMultipartFormRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling uploadMultipartForm.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/saml-multipart`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.uploadOrganizationSettingsImageMultipartRequest,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Upload SAML IdP Metadata XML
     */
    async uploadMultipartForm(requestParameters, initOverrides) {
        const response = await this.uploadMultipartFormRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload organization settings image
     */
    async uploadOrganizationSettingsImageRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling uploadOrganizationSettingsImage.');
        }
        const queryParameters = {};
        if (requestParameters.contentType2 !== undefined) {
            queryParameters['contentType'] = requestParameters.contentType2;
        }
        const headerParameters = {};
        if (requestParameters.contentType !== undefined && requestParameters.contentType !== null) {
            headerParameters['contentType'] = String(requestParameters.contentType);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings/image`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Upload organization settings image
     */
    async uploadOrganizationSettingsImage(requestParameters, initOverrides) {
        const response = await this.uploadOrganizationSettingsImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload organization settings image multipart
     */
    async uploadOrganizationSettingsImageMultipartRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling uploadOrganizationSettingsImageMultipart.');
        }
        const queryParameters = {};
        if (requestParameters.contentType !== undefined) {
            queryParameters['contentType'] = requestParameters.contentType;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/octet-stream';
        if (requestParameters.xContentType !== undefined && requestParameters.xContentType !== null) {
            headerParameters['x-contentType'] = String(requestParameters.xContentType);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/settings/image/multipart`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.uploadOrganizationSettingsImageMultipartRequest,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Upload organization settings image multipart
     */
    async uploadOrganizationSettingsImageMultipart(requestParameters, initOverrides) {
        const response = await this.uploadOrganizationSettingsImageMultipartRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async verifyOrganizationUserAccessChallengeRaw(requestParameters, initOverrides) {
        if (requestParameters.slug === null || requestParameters.slug === undefined) {
            throw new runtime.RequiredError('slug', 'Required parameter requestParameters.slug was null or undefined when calling verifyOrganizationUserAccessChallenge.');
        }
        if (requestParameters.organizationVerifyAccessOptions === null || requestParameters.organizationVerifyAccessOptions === undefined) {
            throw new runtime.RequiredError('organizationVerifyAccessOptions', 'Required parameter requestParameters.organizationVerifyAccessOptions was null or undefined when calling verifyOrganizationUserAccessChallenge.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/organizations/{slug}/verify`.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters.slug))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.organizationVerifyAccessOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async verifyOrganizationUserAccessChallenge(requestParameters, initOverrides) {
        const response = await this.verifyOrganizationUserAccessChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetOrganizationUsersPaginatedSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const InviteOrganizationUsersCsvUserTypeEnum = {
    SOLO: 'SOLO',
    CHILD_SOLO: 'CHILD_SOLO',
    CHILD_TEAM: 'CHILD_TEAM',
    CHILD_ADMIN: 'CHILD_ADMIN'
};
